module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-28.4ba478e6.jpg";